<template>
  <MetaButton data-testid="item-download" :tooltip="tooltip" tooltip-placement="top" :disabled="isEditProcessing" @click="onClick">
    <Icon name="general.download" size="sm" />
  </MetaButton>
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { Icon } from '@/storybook/icon';
import MetaButton from '@/modules/viewer/components/MetaButton.vue';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useItemActions } from '@/modules/viewer/composables/useItemActions';
import { computed } from 'vue';

const viewerItemStore = useViewerItemStore();
const { isEditProcessing } = storeToRefs(viewerItemStore);
const { downloadAction } = useItemActions();

const tooltip = computed(() => {
  if (isEditProcessing.value) {
    return 'Processing';
  }
  return 'Download';
});

const onClick = async () => {
  if (isEditProcessing.value) {
    return;
  }
  await downloadAction();
};
</script>
